'use strict'

const cartChangeEvent = {
    emitEvent (data) {
        const event = new CustomEvent('cartChange', {
            detail: data
        });

        window.dispatchEvent(event);
    }
}

export default cartChangeEvent;
